<div class="content d-flex flex-column flex-column-fluid">
    <div class="toolbar mb-5">
        <div class="container-fluid d-flex flex-stack">
            <div class="page-title d-flex flex-column align-items-start me-3 mb-5 mb-lg-0">

                <h1 class="d-flex text-dark fw-bolder fs-2 flex-column mb-0">
                    <span><i class="far fa-address-book text-success" style="font-size: large;"></i><span></span> Talep
                        Listesi</span>
                    <!-- <span class="text-muted fs-7 fw-bold mt-2">Alt Başlık</span> -->
                </h1>
            </div>
            <div class="d-flex align-items-center gap-2 gap-lg-3">
                <a (click)="talepSayisiKontrol()" class="btn btn-sm  btn-shadow-hover fs-6"
                    style="background-color: #77C2E9; color: white;">
                    <i class="fas fa-plus" style="color: white;"></i>
                    <!--end::Svg Icon-->Yeni Talep Oluştur
                </a>
            </div>
        </div>
    </div>
  
    <div class="post d-flex flex-column-fluid" id="kt_post">
        
        <div id="kt_content_container" class="container-fluid">
            <div class="d-flex align-items-center bg-light-warning rounded p-3 mb-1">
                <!--begin::Icon-->
                <span class="svg-icon svg-icon-warning me-5">
                    <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                    <span class="svg-icon svg-icon-1">
                        <i class="far fa-hand-point-right text-danger" style="font-size: larger;"></i>
                    </span>
                    <!--end::Svg Icon-->
                </span>
                <!--end::Icon-->
                <!--begin::Title-->
                <div class="flex-grow-1 me-2">
                   <b>Listelenen Talepler ile ilgili arama kısmından filtreleme yapabilirsiniz.</b> 
                    <span class="text-muted fw-bold d-block"></span>
                </div>
                
                
                
                <!--end::Title-->
                <!--begin::Lable-->
                <span class="fw-bolder text-warning py-1"></span>
                <!--end::Lable-->
            </div>
            <div class="d-flex align-items-center bg-light-success rounded p-3 mb-3">
                <!--begin::Icon-->
                <span class="svg-icon svg-icon-warning me-5">
                    <!--begin::Svg Icon | path: icons/duotune/abstract/abs027.svg-->
                    <span class="svg-icon svg-icon-1">
                        <i class="far fa-hand-point-right text-danger" style="font-size: larger;"></i>
                    </span>
                    <!--end::Svg Icon-->
                </span>
                <!--end::Icon-->
                <!--begin::Title-->
                <div class="flex-grow-1 me-2">
                    <b>İşleme alınmış veya iptal edilen taleplerde düzenleme işlemi yapılamaz.</b>
                    <span class="text-muted fw-bold d-block"></span>
                </div>
                
                
                
                <!--end::Title-->
                <!--begin::Lable-->
                <span class="fw-bolder text-warning py-1"></span>
                <!--end::Lable-->
            </div>
            <grid #grid [service]="service" [(data)]="kullaniciTalepNebis" [rowCount]="10">
                <div style="overflow:auto;width: 100%;">
                                <table class="table  table-hover  table-responsive gn-middle table-row-bordered fs-6 gy-3" id="kt_subscriptions_table">
                    <thead>
                        <tr class="text-start fw-bolder fs-7 text-uppercase gs-0 " style="color:#009ef7;">
                            <th>#</th>
                            <th class="text-center" style="width: 5%;">Talep No</th>
                            <th class="text-center" style="width: 5%;">Kategori</th>
                            <th class="text-center" style="width: 35%;">Talep İçerik</th>
                            <th class="text-center" style="width: 10%;">Talep Tarihi</th>
                            <th class="text-center" style="width: 10%;">Talep Edilen Birim</th>
                            <th class="text-center" style="width: 10%;">Durum</th>
                            <th class="text-center" style="width: 10%;">Talep Sonucu</th>
                            <th class="text-center" style="width: 15%;">İşlemler</th>
                        </tr>
                    </thead>
                    <tbody class="text-gray-600 fw-bold">
                        <tr *ngFor="let item of kullaniciTalepNebis;let i=index;">
                            <td class="text-info text-left">
                                <b>{{i+1}}</b>
                            </td>
                            <td class="text-info text-center">
                                <b>{{ item.id }}</b>
                            </td>
                            <td class="text-black fw-bold">
                                {{ item.talepKategoriAdi }} 
                            </td>
                            <td>
                                {{ item.aciklama }} 
                            </td>
                            <td class="text-center"> 
                                  <i class="far fa-clock text-success"></i><b> {{ item.kayitTarihi | date:'dd.MM.yyyy - HH:mm'}}</b>
                            </td>
                            <td class="text-center">
                                {{ item.birimAdi }}
                            </td>
                            <td class="text-center" style="color:black">
                               <b> {{ item.durumAdi }}</b>
                            </td>
                            <td class="text-center fw-bolder" style="color: black">
                                <span *ngIf="item?.durumAdi!='İptal Edildi';">
                                <ng-container  *ngIf="item?.kapatildimi==0;else drmNo1;"></ng-container>
                                <ng-template #drmNo1>
                                    <ng-container *ngIf="item?.kapatildimi==1 && item?.olumlumu==1; else drmNo2"> 
                                        Kapatıldı. <br>Olumlu <i class="fas fa-check fs-4 text-success fs-4"></i>
                                        </ng-container>   
                                </ng-template> 
                                <ng-template #drmNo2>
                                    <ng-container *ngIf="item?.kapatildimi==1 && item?.olumlumu==0">
                                        Kapatıldı. <br> Olumsuz <i class="fas fa-times fs-4 text-danger fs-4"></i>
                                        </ng-container>
                                </ng-template>  
                            </span>
                            </td>

                            <td class="text-end">
                                <div class="d-flex justify-content-center flex-shrink-0">
                                    <a [routerLink]="['/talep-ayrinti', item.id]"  data-toggle="tooltip" data-theme="dark" title="Talep Ayrıntısını görmek için tıklayınız."
                                    class="btn btn-icon  btn-active-color-primary btn-sm me-1">
                                    <i class="fas fa-info-circle text-success" style="font-size:x-large;"></i>
                                </a>
                                    <div *ngIf="(item.hareketBilgileri.length<=0 && item.durumAdi!='İptal Edildi')">
                                        <a [routerLink]="[item.localKullaniciTalepId]"  data-toggle="tooltip" data-theme="dark" title="Talebi Düzenlemek için tıklayınız."
                                        class="btn btn-icon  btn-active-color-primary btn-sm me-1">
                                        <i class="fas fa-edit text-info" style="font-size:x-large;"></i>
                                    </a>
                                    <button type="button" (click)="silModal(item)"
                                        class="btn btn-icon btn-active-color-danger btn-sm" data-bs-toggle="modal"
                                        data-bs-target="#sil_modal" title="Talebi İptal etmek için tıklayınız.">
                                        <i class="far fa-trash-alt text-danger" style="font-size:x-large;"></i>
                                    </button>
                                    </div>  
                                </div>								
                            </td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </grid>
        </div>
    </div>
</div>



<div id="sil_modal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <i class="fas fa-trash-alt text-danger" style="font-size: large; padding-right:2px;"></i>
                <h2 class="modal-title">Talep İptal</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="fs-5" *ngIf="silinecekTalepNebis">
                    <b><span style="color:red">{{ silinecekTalepNebis.id }}</span>   nolu talebi iptal etmek istediğinize emin misiniz ?</b> <br> 
                </p>
               
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i
                        class="fas fa-window-close text-info"></i>İptal</button>
                <button type="button" class="btn btn-danger" [disabled]="siliniyor" (click)="sil(silinecekTalepNebis!)"
                    [attr.data-kt-indicator]="siliniyor ? 'on' : 'off'">
                    <span class="indicator-label"><i class="fas fa-trash-alt" style="padding-right:2px;"></i>Sil</span>
                    <span class="indicator-progress">Talep Siliniyor...
                        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>